import {StoreController} from '../store/controllers/StoreController';

const DEFAULT_SCENE_SAVE_MESSAGE = `scene not saved as no name was given`;
export class BaseSaveController {
	constructor() {}
	static updateStatusBarWithNoSave(message = DEFAULT_SCENE_SAVE_MESSAGE) {
		StoreController.editor.status.setMessage(message);
	}
	updateStatusBarWithNoSave(message = DEFAULT_SCENE_SAVE_MESSAGE) {
		BaseSaveController.updateStatusBarWithNoSave(message);
	}
}
